import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // PatternFly's Page component uses its own scrollable <main> container
    // rather than the window, so we need to scroll that element. The id is set
    // via Page's `mainContainerId` prop in Layout.tsx so we don't depend on
    // PatternFly's internal class names.
    const mainContainer = document.getElementById("mvconfigui-page-main");
    if (mainContainer) {
      mainContainer.scrollTop = 0;
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
